/* eslint-disable import/prefer-default-export */

// eslint-disable-next-line no-unused-vars
const defaultFormat = (v, args) => v;

export const getValue = (resource, metaField, attrName, args = {}) => {
  const {
    formatReadOnly = defaultFormat,
    formatValue = defaultFormat,
    defaultValue = '',
  } = args;

  const attrValue = resource.attr(attrName);

  const readOnlyFormatter = metaField.attr('_formatReadOnly');
  if (metaField.attr('readonly')) {
    if (readOnlyFormatter) {
      return readOnlyFormatter(attrValue, { resource, attrName });
    }
    return formatReadOnly(attrValue, { resource, attrName });
  }

  if (!attrValue) {
    return defaultValue;
  }

  const formatter = metaField.attr('_formatValue');
  if (formatter) {
    return formatter(attrValue, { resource, attrName });
  }
  return formatValue(attrValue, { resource, attrName });
};

// props: all props supplied to MetaControl
// spreadPropNames: property override to spread onto the rendered component
export const getSpreadProps = (props, spreadPropNames = []) => spreadPropNames
  .reduce((acc, currKey) => {
    acc[currKey] = props[currKey];

    return acc;
  }, {});

export const getCustomProps = (props, CustomProps, initialCustomProps = {}) => {
  const overriddenCustomProps = {};

  Object.keys(initialCustomProps).forEach((propKey) => {
    const value = initialCustomProps[propKey];
    if (typeof value === 'function') {
      overriddenCustomProps[propKey] = value(props);
    } else {
      overriddenCustomProps[propKey] = value;
    }
  });

  return {
    ...CustomProps,
    ...overriddenCustomProps,
  };
};
